﻿export default class content {
    constructor() {
        this.dom = {
            $: window.$,
            $window: $(window),
            $container: $('.nav-tab'),
            $btnItem: $('.nav-tab__item'),
            $formPageRight: $('.form-page-right'),
            $btnScroll: $('a.scroll-to-form'),
            $btnTab: $('.nav-tab__link'),
            $tabContent: $('.content-tab'),
            $useBKmark: $('.goto-book-mark'),
            $calcPanel: $('.calc-panel'),
            $calcContiner: $('#calcContiner'),
            $sectionCalc: $('section.calc'),
            $calcButton: $('a.btn-rounded:contains("Złóż wniosek")')
        };

        if (this.dom.$container.length > 0 || this.dom.$useBKmark.length > 0 ) {
            this.init();
        }
    }

    init() {
        this.events();
    }

    events() {
        let $thisDom = this.dom;

        //Insert calculator into correct container
        if ($thisDom.$sectionCalc.length > 0 && $thisDom.$calcContiner.length > 0) $thisDom.$calcContiner.append($thisDom.$sectionCalc);

        let offset = 20 + (window.innerWidth < '993' ? 60 : 0);

        this.dom.$useBKmark.on('click', (e) => {
            e.preventDefault();
            let bookMark = $(e.currentTarget).data('book-mark');
            if (bookMark != undefined) {
                //Move page up to top of tabs
                window.scrollTo({ top: $(bookMark).offset().top - offset, behavior: 'smooth' });
            }
        });

        this.dom.$btnScroll.on('click', (e) => {
            e.preventDefault();
            //Move page up to top of tabs
            window.scrollTo({ top: $thisDom.$formPageRight.offset().top - offset, behavior: 'smooth' });
        });

        this.dom.$btnItem.on('click', (e) => {
            e.preventDefault();
            let $clickedBtn = $(e.currentTarget);
            if ($clickedBtn.offset().left > 200) {
                $thisDom.$container.addClass('right-align');
            }
            if ($clickedBtn.offset().left < 100) {
                $thisDom.$container.removeClass('right-align');
            }
            $thisDom.$btnItem.removeClass('active');
            $clickedBtn.addClass('active');
            let href = $clickedBtn.find('a').attr('href').substring(1);

            $thisDom.$tabContent.find('div.content-tab__item--active').removeClass('content-tab__item--active');
            $thisDom.$tabContent.find('#' + href).addClass('content-tab__item--active');

            //Move page up to top of tabs
            $("html, body").animate({ scrollTop: ($thisDom.$container.offset().top) }, 1000);
        });

        this.dom.$calcButton.on('click', (e) => {
            e.preventDefault();

            //Move page up to top of tabs
            $("html, body").animate({ scrollTop: ($thisDom.$calcPanel.offset().top - 70) }, 1000);
        });
    }
}

document.addEventListener('DOMContentLoaded', () => new content());
